import React, { useContext } from 'react';
import Modal from 'components/modal';
import TrendIcon from './components/trend-icon/trend-icon';
import OfferInterface from 'interfaces/offer.interface';
import PriceAlertInterface from '../../../../../modules/price-alert/price-alert.interface';
import { Trend } from 'interfaces/price-history.interface';
import { useFetch } from 'hooks/use-fetch';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { useModal } from 'hooks/use-modal';

const PriceAlertModal = React.lazy(() => import('components/product/product-actions/product-action-price-alert/components/price-alert-modal'));
const PriceAlertModalConfirm = React.lazy(() => import('components/product/product-actions/product-action-price-alert/components/price-alert-modal-confirm'));

const PriceHistoryModalDesktop = React.lazy(() => import('./components/price-history-modal/price-history-modal.desktop'));
const PriceHistoryModalMobile = React.lazy(() => import('./components/price-history-modal/price-history-modal.mobile'));

interface ProductActionPriceHistoryProps {
    offer: OfferInterface;
    price: number;
    productUrl: string;
    productId: number;
}

const ProductActionPriceHistory: React.FC<ProductActionPriceHistoryProps>
    = ({
        offer,
        price,
        productUrl,
        productId
    }) => {
        const api = useContext(TeApiContext);
        const priceHistory = useModal('PRICE_HISTORY');
        const confirmAlert = useModal('ALERT_CONFIRM');
        const priceAlert = useModal('ALERT_PRICE');
        const { post } = useFetch('/alert-cenowy/create');

        if (api === null) {
            throw new Error('Invalid API context');
        }

        const isMobile = api.getDevice() === 'mobile';

        const onSubmit = (formData: PriceAlertInterface): void => {
            confirmAlert.close();

            post({ ...formData, productId }).then(confirmAlert.open);
        };

        return (
            <>
                <button
                    aria-label="Historia ceny"
                    type="button"
                    onClick={priceHistory.open}
                    className={`btn btn--fw-600 btn-action ${api.getDevice()} gtm_ua_pricehistory`}
                >
                    <TrendIcon trend={Trend.constant}/>
                    {api.getDevice() === 'desktop' ? 'Historia ceny' : ''}
                </button>
                {
                    priceHistory.isOpen && (
                        <Modal
                            showCloseIcon={false}
                            center={true}
                            isOpen={true}
                            onClose={priceHistory.close}
                            shouldCloseOnOverlayClick={!isMobile}
                            modalClassName="price-history-modal"
                        >
                            { isMobile
                                ? <PriceHistoryModalMobile
                                    offer={offer}
                                    price={price}
                                    productUrl={productUrl}
                                />
                                : <PriceHistoryModalDesktop
                                    offer={offer}
                                    price={price}
                                    productUrl={productUrl}
                                    onSubmit={onSubmit}
                                />}
                        </Modal>
                    )
                }
                {
                    priceAlert.isOpen && (
                        <Modal
                            showCloseIcon={false}
                            center={true}
                            isOpen={true}
                            onClose={priceAlert.close}
                            shouldCloseOnOverlayClick={true}
                            modalClassName="price-alert-modal"
                        >
                            <PriceAlertModal
                                productPrice={price}
                                formText="Powiadomimy Cię, gdy produkt osiągnie Twoją oczekiwaną cenę."
                                closePriceAlertModal={priceAlert.close}
                                onSubmit={onSubmit}
                            />
                        </Modal>
                    )
                }
                {
                    confirmAlert.isOpen && (
                        <Modal
                            showCloseIcon={false}
                            center={true}
                            isOpen={true}
                            onClose={confirmAlert.close}
                            shouldCloseOnOverlayClick={true}
                            modalClassName="price-alert-modal-confirm"
                        >
                            <PriceAlertModalConfirm onClose={confirmAlert.close}/>
                        </Modal>
                    )
                }
            </>
        );
    };

export default ProductActionPriceHistory;
